import React from "react";

export default function Refund() {
  return (
    <div className="container py-5">

      <h1 className="fw-bold mb-4">Refund Policy</h1>

      <p className="text-muted" style={{ fontSize: "16px" }}>
        This Refund Policy explains the conditions under which refunds may be approved for services
        purchased from <strong>SWIFTSHIP</strong>. Our logistics operations involve third-party
        carriers, customs handling, freight networks, and international routing. Because of this,
        certain fees and services become non-refundable once processing begins.
      </p>

      <hr className="my-4" />

      {/* SECTION 1 */}
      <h3 className="fw-bold">1. Eligibility for Refunds</h3>
      <p className="text-muted">
        Refunds may be approved <strong>only if all of the following conditions are met:</strong>
      </p>

      <ul className="text-muted">
        <li>✔ Shipment has NOT been picked up, dropped off, or received by any carrier</li>
        <li>✔ No airway bill, booking, label, or customs documents have been generated</li>
        <li>✔ No third-party carrier charges have been incurred</li>
        <li>✔ Customer cancellation request is received before shipment processing begins</li>
      </ul>

      <p className="text-muted">
        Once a shipment moves into the processing stage, it becomes non-refundable.
      </p>

      <hr className="my-4" />

      {/* SECTION 2 */}
      <h3 className="fw-bold">2. Non-Refundable Services</h3>
      <p className="text-muted">
        The following fees and services are <strong>strictly non-refundable</strong>:
      </p>

      <ul className="text-muted">
        <li>✔ Freight booking fees (air, sea, domestic carriers)</li>
        <li>✔ Pickup, storage, consolidation, or handling fees</li>
        <li>✔ Customs documentation or compliance processing fees</li>
        <li>✔ Carrier label generation or booking confirmations</li>
        <li>✔ Any service charges already paid to third-party partners</li>
      </ul>

      <p className="text-muted">
        These costs are incurred immediately once processing begins and cannot be reversed.
      </p>

      <hr className="my-4" />

      {/* SECTION 3 */}
      <h3 className="fw-bold">3. Delivery Timeframes (30–45 Days or Longer)</h3>
      <p className="text-muted">
        Customers acknowledge that delivery timelines for domestic and international logistics may
        require <strong>30–45 days or longer</strong> due to:
      </p>

      <ul className="text-muted">
        <li>✔ Customs clearance and government inspections</li>
        <li>✔ Weather delays or seasonal congestion</li>
        <li>✔ Freight routing issues or carrier scheduling</li>
        <li>✔ International regulatory procedures</li>
      </ul>

      <p className="text-muted">
        <strong>Extended delivery times do not qualify for a refund</strong>, cancellation, or
        chargeback request, as they are a standard part of global logistics operations.
      </p>

      <hr className="my-4" />

      {/* SECTION 4 */}
      <h3 className="fw-bold">4. Completed Deliveries</h3>
      <p className="text-muted">
        Once a shipment has been delivered according to the tracking record, signature confirmation,
        proof of delivery (POD), or carrier scan logs, the service is considered fulfilled and:
      </p>

      <ul className="text-muted">
        <li>✔ No refund will be issued</li>
        <li>✔ No partial refund or credit will be granted</li>
        <li>✔ Any disputes must be handled through the carrier’s claims process</li>
      </ul>

      <hr className="my-4" />

      {/* SECTION 5 */}
      <h3 className="fw-bold">5. Lost or Damaged Shipments</h3>
      <p className="text-muted">
        SWIFTSHIP partners with licensed carriers. Lost/damaged shipment claims must be made through
        the carrier’s official process. Refund eligibility depends on:
      </p>

      <ul className="text-muted">
        <li>✔ Carrier investigation results</li>
        <li>✔ Proof of value and supporting documents</li>
        <li>✔ Insurance coverage purchased by the customer</li>
      </ul>

      <p className="text-muted">
        SWIFTSHIP does not guarantee carrier reimbursement unless insurance was purchased.
      </p>

      <hr className="my-4" />

      {/* SECTION 6 */}
      <h3 className="fw-bold">6. Chargeback & Dispute Policy</h3>
      <p className="text-muted">
        To prevent fraudulent disputes and ensure fair processing, customers agree to the following:
      </p>

      <ul className="text-muted">
        <li>✔ Customers must contact SWIFTSHIP to resolve an issue before initiating any chargeback</li>
        <li>✔ Chargebacks filed for delayed delivery (30–45+ days) will be disputed with evidence</li>
        <li>✔ Filing false chargebacks may result in account suspension and legal action</li>
        <li>✔ We maintain proof of delivery, tracking logs, timestamps, carrier scans, and IP/device logs</li>
        <li>✔ Once a shipment is processed or picked up, chargebacks are invalid</li>
      </ul>

      <p className="text-muted">
        Fraudulent disputes are reported to payment processors and may affect the customer's ability to
        use SWIFTSHIP services in the future.
      </p>

      <hr className="my-4" />

      {/* SECTION 7 */}
      <h3 className="fw-bold">7. Refund Processing Time</h3>
      <p className="text-muted">
        If a refund is approved, it will be processed within:
        <br />
        <strong>7–14 business days</strong> depending on your bank or payment gateway.
      </p>

      <hr className="my-4" />

      {/* SECTION 8 */}
      <h3 className="fw-bold">8. Contact for Refund Requests</h3>
      <p className="text-muted">To request a refund review, contact us:</p>

      <p className="mt-2">
        <strong>Email:</strong> info@swiftship.us <br />
        <strong>Address:</strong> 3800 Cabell Dr, Irving, TX 75063, United States <br />
        <strong>Phone:</strong> (480) 520-0274
      </p>

      <p className="text-muted mt-3">
        Refund approval is subject to SWIFTSHIP’s verification and compliance review.
      </p>

    </div>
  );
}
